import { render, staticRenderFns } from "./access-registration-view.vue?vue&type=template&id=79690bac&scoped=true&lang=pug&"
import script from "./access-registration-view.vue?vue&type=script&lang=js&"
export * from "./access-registration-view.vue?vue&type=script&lang=js&"
import style0 from "./access-registration-view.vue?vue&type=style&index=0&id=79690bac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79690bac",
  null
  
)

export default component.exports